import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useEffect, useState } from "react";
import { useLevelSubscriptionDropDownData } from "../../../hooks/dropdown/useLevelSubscriptionDropDownData";


export type subscriptionLevelsValue = {
  value: string;
  label: string;
}

type SubscriptionLevelFilterProps = {
  onChange: (value: string) => void;
  value?: string;
  selectedProductValue: any;
  selectedVersionValue:any;
};


const SelectBoxWrapper = styled.div`
  max-width: 300px;
  min-width: 225px;
`;

export const SubscriptionLevelFilter: React.FC<SubscriptionLevelFilterProps> = ({
  value,
  onChange,
  selectedProductValue,
  selectedVersionValue
}) => {
  const { t } = useTranslation();
  const [subscriptionLevels, setSubscriptionLevels] = useState<any>()

 // const allLevelSubscription = useSubscriptionLevelData(selectedProductValue);
 let allLevelSubscription = useLevelSubscriptionDropDownData(selectedProductValue, selectedVersionValue);

  useEffect(() => {
    
    // //console.log({ allLevelSubscription })
    if (allLevelSubscription && allLevelSubscription.status == "success") {
      setSubscriptionLevels(allLevelSubscription)
    }
  }, [allLevelSubscription])



  let subscriptionLevelData: subscriptionLevelsValue[] = [];
  if (subscriptionLevels && subscriptionLevels.data) {
     //console.log({ subscriptionLevels })
    for (let lsItem of subscriptionLevels.data.list) {
      subscriptionLevelData.push({
        value: lsItem.product_level_code!,
        label: lsItem.product_level_description!
      })
    }
     //console.log({ subscriptionLevelData })
  }


  return (
    <SelectBoxWrapper>
      <Select
        // mode="multiple"
        allowClear
        placeholder={t("licenses.basic.search.level.title")}
        style={{ width: "100%" }}
        maxTagCount={1}
        options={subscriptionLevelData}
        onChange={onChange}
        value={value}
      />
    </SelectBoxWrapper>
  );
};